export const TabList = [
  { label: 'SPOTLIGHT', value: 'SPOTLIGHT' },
  { label: 'VODACOM NOW', value: 'VODACOM NOW' },
  { label: 'TRENDS', value: 'TRENDS' },
  { label: 'SPORTS', value: 'SPORTS' },
  { label: 'NEWS', value: 'NEWS' },
  { label: 'LIFESTYLE', value: 'LIFESTYLE' }
];

export const AdvanceHistoryTab = [
  { value: 'advances', label: 'Advances' },
  { value: 'repayments', label: 'Repayments' }
];

export const Pill = [
  { value: 'Available', label: 'Available' },
  { value: 'Your history', label: 'Your history' }
];

export const VoucherDashboardViews = [
  { value: 'Vouchers', label: 'Vouchers' },
  { value: 'Past Purchases', label: 'Past Purchases' }
];